var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        "custom-class": "check-ranking-query-detail",
        visible: _vm.dialogVisible,
        width: "1200px",
        "append-to-body": "",
        "before-close": _vm.beforeClose,
        fullscreen: true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "check-detail-box" }, [
        _c(
          "div",
          { staticClass: "dfcjsb" },
          [
            _vm.queryType === 3
              ? _c(
                  "el-select",
                  {
                    staticClass: "w220",
                    attrs: { size: "small" },
                    on: { change: _vm.search },
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword",
                    },
                  },
                  _vm._l(_vm.keywordList, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _c("span", { staticClass: "tr", staticStyle: { width: "100%" } }, [
              _vm._v("查询时间：" + _vm._s(_vm.searchTime)),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "tableView mt20",
          },
          [
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      stripe: "",
                      "header-cell-style": _vm.tableHeader,
                      height: "100%",
                      "empty-text": "未查到相关数据",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "关键词", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "textOver",
                                  attrs: { title: row.keyword },
                                },
                                [_vm._v(_vm._s(row.keyword))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "商品信息", width: "540" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.ProductInfo
                                ? _c(
                                    "div",
                                    { staticClass: "dfc" },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          "max-width": "64px",
                                          "max-height": "64px",
                                        },
                                        attrs: {
                                          fit: "contain",
                                          src: _vm._f("alicdnFormat")(
                                            row.ProductInfo.Image.images[0]
                                          ),
                                        },
                                      }),
                                      _c("span", { staticClass: "ml10" }, [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: { width: "64px" },
                                            attrs: {
                                              href: `https://detail.1688.com/offer/${row.offerId}.html?token=${_vm.token}`,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(row.title),
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "mt10 color99" },
                                          [
                                            _vm._v(
                                              " 更新时间：" +
                                                _vm._s(
                                                  _vm._f("formatTime")(
                                                    row.ProductInfo
                                                      .LastUpdateTime
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.queryType === 1
                      ? _c("el-table-column", {
                          attrs: { label: "公司名称" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.companyName)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3128491460
                          ),
                        })
                      : _vm._e(),
                    _vm.queryType === 3
                      ? _c("el-table-column", {
                          attrs: { label: "企业实力" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c("span", { staticClass: "dfc" }, [
                                      row.shilitag
                                        ? _c("img", {
                                            staticStyle: {
                                              "vertical-align": "middle",
                                            },
                                            attrs: {
                                              src: `${_vm.domain}tools/dzPopup/icon/strengthIcon.png`,
                                            },
                                          })
                                        : _vm._e(),
                                      _c("img", {
                                        staticClass: "ml5",
                                        staticStyle: {
                                          "vertical-align": "middle",
                                        },
                                        attrs: {
                                          src: `${_vm.domain}tools/dzPopup/icon/chengIcon.png`,
                                        },
                                      }),
                                      _c("span", { staticClass: "ml5" }, [
                                        _vm._v(
                                          " " + _vm._s(row.companyTag) + " "
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1750644311
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "90天成交额", prop: "tradeBt" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "排名位置",
                        align: "center",
                        "header-align": "center",
                        width: "115",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("p", [
                                _vm._v(" 第"),
                                _c(
                                  "em",
                                  { staticStyle: { color: "#ff9000" } },
                                  [_vm._v(_vm._s(row.pageIndex))]
                                ),
                                _vm._v("个 "),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "类型",
                        align: "center",
                        "header-align": "center",
                        width: "80",
                        prop: "type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "tr mt10 pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.query.pageIndex,
                    "page-size": _vm.query.pageSize,
                    background: "",
                    layout: "prev, pager, next,total, jumper",
                    total: _vm.query.totalCount,
                  },
                  on: { "current-change": _vm.handleCurrentChange },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }